import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import { useData } from '../context/DataProvider'
import { getDiscoveryTags, tagColors } from './Trends';
import { useNavigate } from 'react-router-dom';
import SavedProducts from '../components/Icon/SavedProducts';
import SavedReports from '../components/Icon/SavedReports';
import Settings from '../components/Icon/Settings';
import ArrowRight from '../components/Icon/ArrowRight';
import DeleteReport from '../components/Icon/DeleteReport';
import Delete from '../components/Icon/Delete';
import Rename from '../components/Icon/Rename';
import DeleteModal from '../components/DeleteModal';
import RenameModal from '../components/RenameModel';
import Modify from '../components/Icon/Modify';


const Saved = (props) => {
  const [currentData, setCurrentData] = useState({});
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { data} = useData();
  
  const navigate  = useNavigate();
  const [activeTab, setActiveTab] = useState('products');
  const tableContainerRef = useRef(null);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [isOpenDropdown,setIsOpenDropdown] = useState(false);
  
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  
  const dropdownContainerRef = useRef(null);
 const wrapperRefs = useRef({});

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (openDropdownIndex === null) return;

    const currentWrapper = wrapperRefs.current[openDropdownIndex];

    if (
      currentWrapper &&
      !currentWrapper.contains(event.target)
    ) {
      setOpenDropdownIndex(null);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("click", handleClickOutside);
  };
}, [openDropdownIndex]);

  const handleRename = (currentData) => {
    setOpenDropdownIndex(null);
    setIsRenameModalOpen(true);   
    setCurrentData(currentData); 
  }
  const handleDelete = (currentData) => {
    setOpenDropdownIndex(null);
    setIsDeleteModalOpen(true);
    setCurrentData(currentData);  
  }
  useEffect(() => {
  setOpenDropdownIndex(null);
}, [activeTab]);

  const handleTabChange = (tab) => {
  setActiveTab(tab);
  setOpenDropdownIndex(null);
};
const formatDate = (date_created) => {
  const date = new Date(date_created._seconds * 1000);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
  return (
    <Container style={{ padding: props.newProducts ? '0px' : '30px'}}>
      <DeleteModal data={currentData} type={activeTab} isOpen={isDeleteModalOpen} onClose={() => {
    setIsDeleteModalOpen(false);
    setOpenDropdownIndex(null);
  }} />
        <RenameModal  type={activeTab}  isOpen={isRenameModalOpen} onClose={() => setIsRenameModalOpen(false)}  data={currentData} />
      <Main style={{ 
          paddingTop:  '24px',
          paddingBottom:'24px',
          position: 'relative',
          maxHeight: '80vh',
          overflowY: 'auto' 
        }} ref={tableContainerRef}>
      <M1>
        <M11 onClick={()=>handleTabChange('products')} style={activeTab === 'products' ? { borderBottom: '1px solid #202327' } : {}}>
            <SavedProducts color={activeTab === 'products' ? '#202327' : '#20232799'}/>
            <M11Txt color={activeTab === 'products' ? '#202327' : '#20232799'}>Saved Views</M11Txt>
        </M11>
         <M11 onClick={()=>handleTabChange('reports')} style={activeTab === 'reports' ? { borderBottom: '1px solid #202327' } : {}}>
            <SavedReports color={activeTab === 'reports' ? '#202327' : '#20232799'}/>
            <M11Txt color={activeTab === 'reports' ? '#202327' : '#20232799'}>Saved Reports</M11Txt>
        </M11>
  

      </M1>
      {activeTab === 'products' ? <M2>
        {data?.savedViews?.length > 0 ? data?.savedViews?.map((product,idx)=>{
         const isOpenDropdown = openDropdownIndex === idx;
        return <M21 totalItems={data?.savedViews?.length} onClick={() => navigate('/new-products', { state: { prod:product } })} key={idx}>
            <M211>
                <M2111>
                    <M2111Txt>{product?.title}</M2111Txt>
                    <div
                    ref={(el) => { wrapperRefs.current[idx] = el; }}
                    style={{
                      gap: 10,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                      width: 160,
                      position: 'relative',
                    }}
                  >
                    <SettingsButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDropdownIndex(isOpenDropdown ? null : idx);
                      }}
                      isHovered={isOpenDropdown}
                    >
                      <Settings />
                    </SettingsButton>

                    {isOpenDropdown && (
                      <DropdownDiv>
                        <DropdownOptionDiv
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRename(product);
                          }}
                        >
                          <Rename />
                          <DropdownOptionTxt>Rename</DropdownOptionTxt>
                        </DropdownOptionDiv>
                       
                        <DropdownOptionDiv
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(product);
                          }}
                        >
                          <DeleteReport />
                          <DropdownOptionTxt>Delete</DropdownOptionTxt>
                        </DropdownOptionDiv>
                      </DropdownDiv>
                    )}
                  </div>
                </M2111>
                <M2122>
            <M212Txt>
                    <span style={{color:'#2F323799'}}>Date</span> {formatDate(product?.date_created)}
                </M212Txt> 
                <div style={{borderRadius:1000,background:"#2F323799",width:3,height:3}}/>   
                <M212Txt>
                 <M212Txt>
 {Array.isArray(product?.product_count) ? product.product_count.length : (product?.product_count || 0)} results
</M212Txt>
                </M212Txt>    
                </M2122>
                <M211>
                    <M31Txt>Filters</M31Txt>
                    <M31>
                      {product?.filters?.map((filter,index)=>
                    
                    <M311>
                            <M31Txt2>
                                {filter?.option}
                            </M31Txt2>
                        </M311>
                    )}

                        
                    </M31>
                </M211>
            </M211>
            
        </M21>
})
:
<div style={{height:400,alignItems:'center',width:'100%',display:'flex',justifyContent:'center'}}>
<M11Txt>Saved Views will appear here</M11Txt>
</div>
}
      </M2>
      
    :
    <M2 >
      
     {data?.savedReports?.length > 0 ? data?.savedReports?.map((report, idx) => {
      
              const isOpenDropdown = openDropdownIndex === idx;

              return (
                <M4 key={idx}>
                  <M41>
                    <M411>
                      <M41Txt>{report.title}</M41Txt>
                      <M2122>
                        <M212Txt>
                          <span style={{ color: '#2F323799' }}>Date</span> {report?.date_created ? formatDate(report.date_created) : 'N/A'}
                        </M212Txt>
                        <div style={{ borderRadius: 1000, background: '#2F323799', width: 3, height: 3 }} />
                        <M212Txt>{Array.isArray(report?.product_count) ? report.product_count.length : (report?.product_count || 0)} results</M212Txt>
                      </M2122>
                    </M411>
                    <RunReport onClick={() => navigate('/report-builder', { state: { report,savedReport:true } })} >
                      <RunReportTxt>Run Report</RunReportTxt>
                      <ArrowRight />
                    </RunReport>
                  </M41>

                  <M211 style={{ width: '60%' }}>
                    <M42Txt>Conditions</M42Txt>
                    <M2122 style={{ flexWrap: 'wrap' }}>
                      
                     
                      {report?.conditions?.map((condition)=>
                      condition.values?.map((value) => (<M42>
                        <M11Txt color="#20232799">{condition.logic?.charAt(0).toUpperCase() + condition.logic?.slice(1)}{" "}
                          {condition.combination} {condition.table}
                        </M11Txt>
                        <M11Txt>{value.name}</M11Txt>
                      </M42>)))}
                    </M2122>
                  </M211>

                  <div
                    ref={(el) => { wrapperRefs.current[idx] = el; }}
                    style={{
                      gap: 10,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                      width: 160,
                      position: 'relative',
                    }}
                  >
                    <SettingsButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDropdownIndex(isOpenDropdown ? null : idx);
                      }}
                      isHovered={isOpenDropdown}
                    >
                      <Settings />
                    </SettingsButton>

                    {isOpenDropdown && (
                      <DropdownDiv style={{top:38}}>
                        <DropdownOptionDiv
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRename(report);
                          }}
                        >
                          <Rename />
                          <DropdownOptionTxt>Rename</DropdownOptionTxt>
                        </DropdownOptionDiv>

                        <DropdownOptionDiv
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(report);
                          }}
                        >
                          <DeleteReport />
                          <DropdownOptionTxt>Delete</DropdownOptionTxt>
                        </DropdownOptionDiv>
                      </DropdownDiv>
                    )}
                  </div>
                </M4>
              );
            })
            
            :
<div style={{height:400,alignItems:'center',width:'100%',display:'flex',justifyContent:'center'}}>
<M11Txt>Saved Reports will appear here</M11Txt>
</div>
            }
        
        
       
    </M2>
    }
      
    
      </Main>
     
      
    </Container>
  );
};

export default Saved;
const SettingsButton = styled.button`
border:none;
background:none;
cursor:pointer;
width: 32px;
height: 32px;
angle: 0 deg;
opacity: 1;
border-radius: 8px;
padding: 6px;
gap: 8px;
background: ${props => props.isHovered ? '#FFFFFF' : 'none'};

`
const DropdownDiv = styled.div`
  position: absolute;
  top: calc(100% + 6px); /* sits just below the settings button */
  right: 0;              /* right-aligned since wrapper uses alignItems: end */
  width: 143px;
  height: 78px;
  opacity: 1;
  border-radius: 10px;
  padding: 2px;
  background: #FFFFFF;
  box-shadow: 0px 10px 24px 0px #2F32370A;
  display: flex;
  flex-direction: column;
  z-index: 100;
`;
const DropdownOptionDiv = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  width: 139px;
  height: 37px;
  opacity: 1;
  border-radius: 8px;
  padding: 10px;
  gap: 10px;
  display: flex;
  align-items: center;
  color: #20232799; /* default color, inherited by children via currentColor */
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;

  &:hover {
    background: linear-gradient(
      90deg,
      rgba(220, 255, 173, 0.3) 0%,
      rgba(246, 255, 219, 0.3) 50%,
      rgba(189, 222, 255, 0.3) 100%
    );
    color: #202327; /* red on hover, cascades to text + icon */
  }
`;

const DropdownOptionTxt = styled.p`
  font-family: PP Mori;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  margin: 0;
  color: inherit; /* was defaulting to a fixed gray — now follows parent */
`;

const DiscoveryTagPill = styled.div`
  padding: 5px 8px;
  border-radius: 6px;
  font-family: PP Mori;
  font-weight: 800;
  font-size: 11px;
  line-height: 120%;
  white-space: nowrap;
  background: ${({ color }) => tagColors[color]?.bg || '#2023271A'};
  color: ${({ color }) => tagColors[color]?.text || '#202327'};
`;
const Tag = styled.div`
  height: 22px;
  border-radius: 4px;
  gap: 10px;
  padding-right: 8px;
  padding-left: 8px;
  justify-content: center;
  align-items: center;
  display: flex;

  /* Dynamically use the passed bgColor prop */
  background: ${props => props.bgColor || 'transparent'};
`;
const TagText = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 10px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;

text-transform: uppercase;
color: #202327;

`
const M1 = styled.div`

height: 68px;
gap: 24px;
angle: 0 deg;
opacity: 1;
border-bottom: 1px solid #2F32371A;
padding-top: 24px;

padding-right: 24px;
padding-left: 24px;


display: flex;

`
const M11 = styled.div`
display:flex;
cursor:pointer;
align-items:center;
height: 44px;
gap: 8px;
angle: 0 deg;
opacity: 1;
border-bottom:1px solid transparent; 
padding-top: 12px;
padding-right: 16px;
padding-bottom: 12px;

padding-left: 16px;

`
const M11Txt = styled.p`
  font-family: PP Mori;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  leading-trim: NONE;
  margin:0;
  line-height: 120%;
  color: ${props => props.color || '#202327'};
  letter-spacing: 0%;
`
const M42Txt = styled.p`
color:#2F323799;
font-family: PP Mori;
font-weight: 500;
font-style: Medium;
font-size: 14px;
leading-trim: NONE;
margin:0;
line-height: 120%;
letter-spacing: 0%;
`
const M2 = styled.div`
display:flex;
flex-wrap:wrap;
padding:24px;
gap:16px;`
const M211 = styled.div`
gap:8px;
display:flex;
flex-direction:column;
`
const M31 = styled.div`
gap:4px;
display:flex;
flex-wrap:wrap;`
const M311 = styled.div`
height: 43px;
gap: 8px;
angle: 0 deg;
opacity: 1;
border-radius: 12px;
padding: 12px;
background: #FFFFFF;
`
const M31Txt2 = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
color: #202327;
margin:0;
`
const M31Txt = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
color: #2F323799;

`
const M42 = styled.div`

// height: 43px;
gap: 6px;
display:flex;

angle: 0 deg;
opacity: 1;
border-radius: 12px;
padding: 12px;
background: #FFFFFF;

`
const M2122 = styled.div`

align-items:center;
gap:8px;
display:flex;`
const M2111 = styled.div`
justify-content:space-between;
align-items:center;

width:100%;
display:flex;
`

const M212Txt = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
color: #2F3237;
margin:0;
`
const M2111Txt = styled.p`
font-family: PP Mori;
margin:0;
font-weight: 600;
font-style: SemiBold;
font-size: 24px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
// text-align: center;

vertical-align: bottom;
color: #202327;
`

const M21 = styled.div`
 width: ${props => (props.totalItems === 1 ? '25%' : 'calc(33.333% - 20px)')};
  // max-width: ${props => (props.totalItems === 1 ? '25%' : '362.66px')};
  
  min-height: 203px;
  cursor: pointer;
  gap: 30px;
  border-radius: 18px;
  padding: 24px;
  background: #F9F9F9;
  opacity: 1;
  box-sizing: border-box;
`;
const M4 = styled.div`
width: 100%;
min-height: 174px;
gap: 30px;
display:flex;
justify-content:space-between;
angle: 0 deg;
opacity: 1;
border-radius: 18px;
padding: 24px;
background: #F9F9F9;

`
const M411 = styled.div`
display:flex;
flex-direction:column;
gap: 16px;
angle: 0 deg;
opacity: 1;
`
const M41 = styled.div`

min-height: 126px;

width:30%;
gap: 24px;
display:flex;
flex-direction:column;
angle: 0 deg;
opacity: 1;

`
const RunReport = styled.button`
width: 137px;
height: 40px;
cursor:pointer;
gap: 8px;
display:flex;
align-items:center;
angle: 0 deg;
opacity: 1;
border-radius: 1000px;
border:none;
padding-right: 16px;
padding-left: 20px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
`
const RunReportTxt = styled.p`

font-family: PP Mori;
font-weight: 800;
font-style: ExtraBold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
margin:0;
vertical-align: bottom;
text-transform: uppercase;
`


const M41Txt = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 24px;

line-height: 120%;
letter-spacing: -1%;
margin:0;

color:#202327;
`
const Container = styled.div`

gap: 30px;
border: 0px 1px 0px 0px;
opacity: 0px;
// height:100%;

`

const Main = styled.div`

gap: 24px;
border-radius: 24px;
background: #FFFFFF;
// overflow:scroll;
 overflow: hidden;
box-shadow: 0px 0px 24px 0px #2F323705;
height:100%;
display:flex;

flex-direction:column;



opacity: 0px;
`
const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  padding-right:12px;
  padding-left:12px;

   white-space: normal;        
  word-break: break-word;    
  overflow-wrap: break-word; 

  
`;

const DropdownInput = styled.div`
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  color: #20232799;
  border: 1px solid #d1d1d1;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  align-items: center;
  padding: 12px;
  

gap: 0px;
border-radius: 12px;
display:flex;


  
border:none;
  outline:none;
  &:hover {
    border-color: #000; /* Optional hover effect */
  }
`;

const OptionsList = styled.ul`
  position: absolute;
  
  top: calc(100% + 4px);
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0px ;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(24, 25, 26, 0.1);
  z-index: 10000000;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  
`;

const DropdownOption = styled.li`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #202327;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    
    
  }
`;






